import React, { Component } from 'react';
import Auxiliary from '../../hoc/Auxiliary/Auxiliary';
import Head from '../../components/Head/Head'
import { withTranslation } from 'react-i18next';
import Page404 from '../Errors/Page404/Page404';
import Banner from '../../components/Blog/NewBanner/NewBanner';

class New extends Component {
    render(){
        const id = this.props.match.params.id;
        const news = this.props.i18n.getResource(this.props.i18n.language,'blog');
        let headId = '';
        let renderNew = <Page404 /> 
        if( typeof news.news[id] !== 'undefined' && !news.news[id].link ){
            headId = 'news.'+id;
            renderNew = <Banner {...this.props} id={id} new={news.news[id].content} news={news.news} alt='' />;
        }
        return (
            <Auxiliary>
                <Head id={headId} />
                {renderNew}
            </Auxiliary>
        );
    }
}

export default withTranslation()(New);